module.exports = __webpack_public_path__ + "img/icon-premium.9be9051e.svg";